var render, staticRenderFns
import script from "./bar-chart-month.vue?vue&type=script&lang=js"
export * from "./bar-chart-month.vue?vue&type=script&lang=js"
import style0 from "./bar-chart-month.vue?vue&type=style&index=0&id=451309d9&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "451309d9",
  null
  
)

export default component.exports